var map = {
	"./apple.png": 2192,
	"./back.png": 12679,
	"./call.png": 48642,
	"./check.png": 77644,
	"./faceBookColored.png": 83070,
	"./faceBookIcon.png": 33969,
	"./facebook.png": 20750,
	"./filter.png": 47140,
	"./google.png": 58031,
	"./group.png": 73741,
	"./instaColored.png": 69839,
	"./instagram.png": 11948,
	"./linkedin.png": 27048,
	"./linkedinColored.png": 31372,
	"./logo.png": 95295,
	"./logo2.png": 36861,
	"./mail.png": 59351,
	"./microsoft.png": 87792,
	"./miniLogo.png": 51466,
	"./next.png": 49909,
	"./profile.png": 92751,
	"./qrCode.png": 92472,
	"./scanner.png": 70370,
	"./search.png": 62274,
	"./settings.png": 32521,
	"./signOut.png": 10725,
	"./twitter.png": 76065,
	"./twitterColored.png": 17651,
	"./uploadCloud.png": 53210,
	"./youtube.png": 10539,
	"./youtubeColored.png": 72889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58160;